module.exports = "/static/assets/c32885db098a1e103a46e711e9244946.png";